<div *ngIf="this.isLoading === true">
	<div>
		<ng-container *ngIf="!isChildFundraiser; else parentFundraiserAbout">
			<app-quill-view
				*ngIf="fundraiserDescriptionData && (fundraiserDescriptionData?.translations?.['content'+localeSuffix] || fundraiserDescriptionData?.content)"
				[quillContent]="fundraiserDescriptionData?.translations?.['content'+localeSuffix] || fundraiserDescriptionData?.content "
			>
			</app-quill-view>
			<a
				*ngIf="this.fundraiserDescriptionData?.content?.includes('....')"
				i18n="@@share_update_messageReadmore"
				class="read-more cursor-pointer"
				(click)="onReadMoreClick()"
			>
				Read More
			</a>
		</ng-container>
	</div>
	<div *ngIf="this.currentFundraiser?.image_list[0]" ngClass="p-t-m p-l-s">
		<ng-image-slider
			[videoAutoPlay]="true"
			[images]="fundraiserMediaList"
			[imageSize]="{ height: 150 }"
			[manageImageRatio]="true"
			[imagePopup]="false"
			(imageClick)="openCustomDialog($event, fundraiserMediaList)"
			[showArrow]="mediaLength > 2 ? true : false"
			#nav
		></ng-image-slider>
	</div>

	<ng-template #parentFundraiserAbout>
		<div fxLayout="row" *ngIf="parentFundraiserAboutcontent">
			<app-quill-view [quillContent]="parentFundraiserAboutcontent">
			</app-quill-view>
		</div>
		<a
			*ngIf="parentFundraiserAboutcontent?.includes('....')"
			i18n="@@share_update_messageReadmore"
			class="read-more cursor-pointer"
			(click)="onReadMoreClick()"
		>
			Read More
		</a>
	</ng-template>
</div>

<div *ngIf="this.isLoading === false">
	<app-page-loader></app-page-loader>
</div>
